import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { FLEX } from '@v4/constants/quiz'
import clsx from 'clsx'
import WhiteThemeProvider from '@v4/components/sections/Question/Components/WhiteThemeProvider'
import InputField from '../../components/InputField'
import SubmitButton from '../../components/SubmitButton'
import { useText } from './Text.hooks'
import { STATIC_CLASSES } from './Text.const'

const TextType = props => {
	const [
		{ classes, multiline, maxChar, justify, pending, value, amount, withBgImage },
		{ handleSubmit, handleChange },
	] = useText(props)

	return (
		<Box className={clsx(classes.root, classes.fullWidth, 'q-text')}>
			<WhiteThemeProvider>
				<InputField
					classes={STATIC_CLASSES}
					justify={justify}
					multiline={multiline}
					amount={amount}
					value={value}
					withBgImage={withBgImage}
					maxLength={maxChar}
					onChange={handleChange}
				/>
			</WhiteThemeProvider>
			<Box className="q-text-button-container" display="flex" mt={1} justifyContent={justify}>
				<SubmitButton loading={pending} className="q-text-button" onClick={handleSubmit} />
			</Box>
		</Box>
	)
}

TextType.propTypes = {
	justify: PropTypes.oneOf(Object.values(FLEX)),
	onClick: PropTypes.func,
	pending: PropTypes.bool,
	withBgImage: PropTypes.bool,
}

TextType.defaultProps = {
	justify: FLEX.START,
	pending: false,
	withBgImage: false,
	onClick: () => {},
}

export default memo(TextType)
